<template>
  <div style="width: 100%">
    <v-card outlined class="px-3" width="100%">
      <v-container>
        <h4 style="margin-left: -12px;" class="mb-1">Info</h4>
        <v-row>
          <v-text-field
            v-model="hostsInput"
            type="text"
            label="Event Hosts"
            required
            dense
          ></v-text-field>
        </v-row>
        <v-row>
          <v-select
            v-model="dressCodeInput"
            :items="dressCodeOptions"
            label="Dress Code Tags"
            required
            dense
          ></v-select>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>

    export default {
        name: 'EventsInfoCard',
        props:{
            dressCode: {
                type: String,
                required: false,
                default: 'Every Day'
            },
            hosts: {
                type: String,
                required: false,
                default: ''
            }
        },
        watch: {
            dressCodeInput (newValue) {
                this.$emit('update:dressCode', newValue);
            },
            hostsInput (newValue) {
                this.$emit('update:hosts', newValue);
            },
            hosts (newValue) {
                this.hostsInput = newValue;
                this.$emit('update:hosts', newValue);
            },
            dressCode (newValue) {
                this.dressCodeInput = newValue;
                this.$emit('update:dressCode', newValue);
            }
        },
        data() {
            return {
                dressCodeInput: this.dressCode,
                hostsInput: this.hosts,
                dressCodeOptions: ['Every Day', 'Ears and Tails', 'Formal', 'Suit Ready']
            }
        }
    }
</script>
<style>
</style>
